/**
 * LianeSoap.tsx — /liane-soap landing page (ليان صوب)
 * Fully isolated brand: all visuals scoped under `.liane-root` (src/styles/liane.css)
 * and `l-*` Tailwind tokens, so the إتقان design system is untouched.
 */
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { site } from "@/content/liane-site.ar";
import { Navbar } from "@/components/liane/Navbar";
import { Hero } from "@/components/liane/Hero";
import { About } from "@/components/liane/About";
import { Ingredients } from "@/components/liane/Ingredients";
import { Occasions } from "@/components/liane/Occasions";
import { Gallery } from "@/components/liane/Gallery";
import { Works } from "@/components/liane/Works";
import { HowToOrder } from "@/components/liane/HowToOrder";
import { OrderBuilder } from "@/components/liane/OrderBuilder";
import { FAQ } from "@/components/liane/FAQ";
import { Footer } from "@/components/liane/Footer";
import { StickyWhatsAppBar, WhatsAppFab } from "@/components/liane/WhatsAppCtas";
import "@/styles/liane.css";

const LianeSoap = () => {
  const [presetOccasion, setPresetOccasion] = useState("");

  useEffect(() => {
    const html = document.documentElement;
    const prevDir = html.getAttribute("dir");
    const prevLang = html.getAttribute("lang");
    html.setAttribute("dir", "rtl");
    html.setAttribute("lang", "ar");
    return () => {
      if (prevDir) html.setAttribute("dir", prevDir);
      if (prevLang) html.setAttribute("lang", prevLang);
    };
  }, []);

  const selectOccasion = (occasion: string) => {
    setPresetOccasion(occasion);
    document.getElementById("order")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="liane-root" dir="rtl" lang="ar">
      <Helmet>
        <title>{site.seo.title}</title>
        <meta name="description" content={site.seo.description} />
        <meta property="og:title" content={site.seo.title} />
        <meta property="og:description" content={site.seo.description} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="icon" href="/liane-favicon.png" type="image/png" />
      </Helmet>

      <Navbar />
      <main>
        <Hero />
        <About />
        <Ingredients />
        <Occasions onSelect={selectOccasion} />
        <Gallery />
        <Works />

        <HowToOrder />
        <OrderBuilder presetOccasion={presetOccasion} />
        <FAQ />
      </main>
      <Footer />
      <StickyWhatsAppBar />
      <WhatsAppFab />
    </div>
  );
};

export default LianeSoap;
